<script>
  import { createEventDispatcher } from "svelte"
  import { onMount } from "svelte"
  import { getEquallySpacedColors } from "../../../../../../../../Script/colors"
  export let textColor
  export let backgroundColor
  export let activeTab
  export let column
  export let colorCount
  // export let

  const dispatch = createEventDispatcher()

  /**
   * @type {Array} list of standard colors
   */
  let standardColors = []
  // let standardColors = ["#fee2e2", "#fef08a", "#c4b5fd", "#fecdd3", "#8b0000", "#FF0000", "#ffa500", "#FFFF00", "#90ee90", "#008000", "#add8e6", "#0000FF", "#00008b"]

  /**
   * @type {Number} Width of the individual color box
   */
  let width

  /**
   * @type {HTMLElement} binded the overall palette container
   */
  let container

  let sharedWidth

  let fixedWidth

  let windowWidth

  onMount(() => {
    resizePalette()
    let fetchedColors = getEquallySpacedColors(colorCount)
    standardColors = ["#000000", "#ffffff", ...fetchedColors]
  })

  /**
   * @description function for adding the new selected standard color
   * @param e targetting binded value to add the color to the existing array
   */
  const addStandardColor = (e) => {
    //assigning targetted value
    activeTab == "bgClr" ? (backgroundColor = e.target.value) : (textColor = e.target.value)

    // eliminating first element from the standardColors
    standardColors.shift()

    //new element added to the array
    standardColors = [...standardColors, e.target.value]
  }

  const resizePalette = () => {
    // Adjust the size of the palette element based on the window width

    // Check the window width and set the fixed width of the palette element
    if (window.innerWidth > 1280) fixedWidth = 49.6
    else if (window.innerWidth > 1024) fixedWidth = 45
    else if (window.innerWidth > 768) fixedWidth = 40
    else if (window.innerWidth > 640) fixedWidth = 35
    else fixedWidth = 30

    // Calculate the shared width for each color in the palette element
    sharedWidth = container.clientWidth / (fixedWidth * 7)

    // Calculate the final width of each color in the palette
    width = fixedWidth + sharedWidth
  }
</script>

<svelte:window
  on:resize={() => {
    // windowWidth = window.innerWidth
    // resizePalette()
  }}
/>

<div bind:this={container}>
  <!-- <div class="mt-3 grid gap-2" style="grid-template-columns: repeat(auto-fit, minmax({width}px,1fr));"> -->
  <div class="mt-3 grid gap-2" style="grid-template-columns: repeat({column}, 1fr);">
    {#if activeTab == "bgClr"}
      <button
        type="button"
        on:click={() => {
          backgroundColor = "transparent"
        }}
        class="relative flex h-[28.8px] w-[52.4px] items-center justify-center"
      >
        <div class="flex h-full w-full items-center justify-center rounded border border-[#a0a1a580] bg-transparent">
          <i class="fa-solid fa-ban text-gray-200" />
        </div>
      </button>
    {/if}
    {#each standardColors as stdColor}
      <button
        on:click={() => {
          if (activeTab == "bgClr") {
            backgroundColor = stdColor
            dispatch("bgClrChosen")
          } else {
            textColor = stdColor
            dispatch("textClrChosen")
          }
        }}
        class="h-[28.8px] rounded hover:scale-110 hover:shadow-colorShadow {backgroundColor == stdColor && activeTab == 'bgClr' ? 'ring-1 ring-[#a0a1a533]' : ''} {textColor == stdColor && activeTab != 'bgClr' ? 'ring-1 ring-[#a0a1a533]' : ''}"
        style="background-color:{stdColor}"
      />
    {/each}
    <div class="relative flex h-[28.8px] w-[52.4px] items-center justify-center pr-0.5">
      <div class="flex h-full w-[52.4px] items-center justify-center rounded border border-[#a0a1a580] bg-transparent">
        <i class="fa-solid fa-plus text-gray-200" />
      </div>
      <input
        on:input={(e) => {
          activeTab == "bgClr" ? (backgroundColor = e.target.value) : (textColor = e.target.value)
        }}
        on:change={addStandardColor}
        type="color"
        class="absolute inset-0 h-full cursor-pointer opacity-0"
      />
    </div>
  </div>
</div>
